<template>
  <div :class="$style.component">
    <div
      v-for="(row, index) in item.table"
      :key="`row-${index}`"
      :class="$style.row"
    >
      <div :class="$style.key" v-html="row.key" />
      <div :class="$style.value" v-html="row.value" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" module>
.component {
  margin: var(--blank-line) 0;
}

.row {
  display: flex;
}

.key {
  flex: 0.5;
  max-width: 10em;
  padding-right: var(--gutter);
}

.value {
  flex: 1;
}
</style>
